module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-about@3x-b8c480650810975728c4878768071857.png";